/**
 * Created by Ning Jiang on 2021-05-05.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export enum Layers {
    // Layers order from the top to the bottom.
    SPLASH_INTRO = "splash_intro",
    SOFT_WIN_CAP_PICK = "soft_win_cap_pick",
    SCREENS = "screens",
    WIN_COUNT_UP = "win_count_up",
    BIG_WIN = "big_win",
    WIN_PRESENTATIONS = "win_presentations",
    FOREGROUND = "foreground",
    ACTIVE_SILHOUETTE = "active_silhouette",
    MID_SYM_EXPAND = "mid_sym_expand",
    FS_STATIC_VIEW = "fs_static_view",
    XSPLIT_VIEW = "xSplit_view",
    ANTICIPATION_VIEW = "anticipation_view",
    X_BET = "x_bet",
    HIGH_SYMBOLS_WIN = "high_symbols_win",
    LOW_SYMBOLS_WIN = "low_symbols_win",
    HIGH_SYMBOLS = "high_symbols",
    LOW_SYMBOLS = "low_symbols",
    REEL_BACKGROUND = "reel_background",
    BACKGROUND = "background"
}

export class SimpleStageLayer extends PIXI.Container implements StageLayer {

    constructor() {
        super();
    }

    // Note: these only check the direct children.
    public onResize(): void {
        this.children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
        });
    }

    public onOrientationChanged(): void {
        this.children.forEach((c: any) => {
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        });
    }

    public addChild<T extends PIXI.DisplayObject>(...children: T[]): T {
        children.forEach((c: any) => {
            if (c.onResize) {
                c.onResize();
            }
            if (c.onOrientationChanged) {
                c.onOrientationChanged();
            }
        })

        return super.addChild(...children);
    }
}

export class RockBottomLayers {

    constructor() {
        for (const key in Layers) {
            NolimitApplication.addLayerAt((<any>Layers)[key], new SimpleStageLayer(), 0);
        }
    }

    public static getLayer(name: string): SimpleStageLayer | undefined {
        return NolimitApplication.getLayerByName(name) as SimpleStageLayer;
    }
}